import "../styles/trade-in-register.scss";
import { useRef, useState, useEffect, useCallback } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import langs from "../../../common/services/languageService.js";
import Button from "../../ui/button/Button.jsx";
import LoadingCounter from "../../ui/loading-counter/loading-counter.jsx";
import Container from "react-bootstrap/Container";

const { labels } = langs;

function TradeInLayout({
  showReCaptcha = false,
  buttonLabel,
  buttonEnabled,
  handleButtonClick,
  isLoading,
  children,
  buttonHidden = false,
  setCaptchaResetHandler,
}) {
  const recaptchaRef = useRef(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [, setCaptchaToken] = useState(null);
  const captchaStorageKey = "captchaToken";

  const handleCaptchaChange = (token) => {
    setCaptchaVerified(true);
    setCaptchaToken(token);
    localStorage.setItem(captchaStorageKey, token);
  };

  const handleCaptchaErrored = () => {
    setCaptchaVerified(false);
    setCaptchaToken(null);
    localStorage.setItem(captchaStorageKey, null);
    recaptchaRef.current?.reset();
  };

  const handleSubmit = () => {
    if (showReCaptcha && !captchaVerified) {
      recaptchaRef.current?.reset();
      return;
    }

    handleButtonClick();
  };

  const handleCaptchaReset = useCallback(() => {
    setCaptchaVerified(false);
    recaptchaRef.current?.reset();
  }, [recaptchaRef]);

  useEffect(() => {
    if (handleCaptchaReset !== null) {
      setCaptchaResetHandler(() => handleCaptchaReset);
    }
  }, [setCaptchaResetHandler, handleCaptchaReset]);

  return (
    <Container>
      <div className="tradein">
        {isLoading && <LoadingCounter />}
        <div className="tradein__header">
          <div className="smallContainer">
            <p>{labels.TradeInFormHeader()}</p>
            <p className="bold">{labels.Ploom()}</p>
          </div>
        </div>
        <div className="tradein__body">
          <div className="smallContainer">{children}</div>
        </div>
        <div className="tradein__footer smallContainer">
          <div className="re-captcha">
            <ReCAPTCHA
              ref={recaptchaRef}
              hidden={!showReCaptcha} //INFO workaround for https://github.com/google/recaptcha/issues/269#issuecomment-2103062534
              sitekey={window.config.captchaKey}
              onChange={handleCaptchaChange}
              onExpired={handleCaptchaErrored}
              onErrored={handleCaptchaErrored}
            />
          </div>
          {buttonHidden || (
            <Button
              type="button"
              className="fs-6 submit-button"
              disabled={!buttonEnabled || (showReCaptcha && !captchaVerified)}
              onClick={handleSubmit}
            >
              {buttonLabel}
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
}

export default TradeInLayout;
